import type {
	ParsedLayout,
	ParsedStructuredElementType,
	PeopleEntityElementType,
	PeopleEntityListElementType,
} from './types';

/**
 * Unique trimmed `accountId`s from direct `people-entity` children of a `people-entity-list`,
 * in document order (skips strings and non-`people-entity` children).
 */
export function getUniquePeopleEntityAccountIdsFromList(
	list: PeopleEntityListElementType,
): string[] {
	const listChildren = Array.isArray(list.children) ? list.children : [];
	const accountIds: string[] = [];
	const seen = new Set<string>();
	for (const child of listChildren) {
		if (typeof child === 'string') {
			continue;
		}
		const structured = child as ParsedStructuredElementType;
		if (structured.tag !== 'people-entity') {
			continue;
		}
		const raw = (structured as PeopleEntityElementType).attributes?.accountId?.trim();
		if (!raw || seen.has(raw)) {
			continue;
		}
		seen.add(raw);
		accountIds.push(raw);
	}
	return accountIds;
}

export const getFirstFoldableSectionIdx = (parsedAnswer: ParsedLayout): number => {
	let firstFoldableSectionIdx = -1;
	for (let i = 0; i < parsedAnswer.length; i++) {
		if (parsedAnswer[i].attributes?.folded === '1') {
			firstFoldableSectionIdx = i;
			break;
		}
	}

	return firstFoldableSectionIdx;
};
